var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalUnresolvedTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 19.9999C21.1545 19.9999 25.3332 15.8212 25.3332 10.6666C25.3332 5.51193 21.1545 1.33325 15.9998 1.33325C10.8452 1.33325 6.6665 5.51193 6.6665 10.6666C6.6665 15.8212 10.8452 19.9999 15.9998 19.9999Z",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9468 18.5199L9.3335 30.6666L16.0002 26.6666L22.6668 30.6666L21.0535 18.5066",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUnresolvedTasks);
export default __webpack_public_path__ + "static/media/total-unresolved-tasks.54ad90e8.svg";
export { ForwardRef as ReactComponent };